import { Component, Input, Output, EventEmitter } from '@angular/core';
import { SharedService } from '../core/service/shared.service';

@Component({
  selector: 'app-ticket-close',
  templateUrl: './ticket-close.component.html',
  styleUrls: ['./ticket-close.component.sass']
})
export class TicketCloseComponent {
  ticketId = 101;
  isResolving = false;
  message = '';

  tickets = [
    { id: 101, title: 'Login page error', priority: 'High', assignedTo: 'John', status: 'Open' },
    { id: 102, title: 'API timeout issue', priority: 'Medium', assignedTo: 'Alice', status: 'Open' },
    { id: 103, title: 'UI misalignment', priority: 'Low', assignedTo: 'Bob', status: 'Resolved' },
  ];

  resolveTicket(ticket: any) {
    ticket.status = 'Resolved';
    this.message = `Ticket #${ticket.id} resolved successfully!`;
  }

  closeTicket(ticket?: any) {
    if (ticket) {
      ticket.status = 'Closed';
      this.message = `Ticket #${ticket.id} closed successfully!`;
    } else {
      // close main ticket
      this.isResolving = true;
      setTimeout(() => {
        this.isResolving = false;
        this.message = `Ticket #${this.ticketId} closed successfully!`;
      }, 1000);
    }
  }
}

